import React from 'react'

const LoadingModal = () => (
  <div>
    <img className="w-100" src="https://leatherspa.imgix.net/LS_Logo-Anim_1000x1000.gif" />
  </div>
)

export default LoadingModal
